import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } };

  connect() {
    requestAnimationFrame(() => this.element.classList.remove('translate-x-full', 'opacity-0'));
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue);
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  dismiss() {
    this.element.classList.add('opacity-0', 'translate-x-full');
    this.element.addEventListener('transitionend', () => this.element.remove(), { once: true });
  }
}
